import { Route, Routes } from "react-router-dom";
import "./App.css";
import RichTextField from "./components/RichTextField";
import Setup from "./components/Setup";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/setup" element={<Setup />} />
        <Route path="/psi-rich-text-field" element={<RichTextField />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </div>
  );
}

const Home = () => (
  <header className="App-header">
    <p>Hygraph Custom Fields App.</p>
  </header>
);

export default App;
